import { createTheme } from '@mui/material/styles';

// Create a theme instance matching the Investec Payment Operations UI
const theme = createTheme({
  palette: {
    primary: {
      main: '#0066b7', // Investec blue from the image
      light: '#4d8ac7',
      dark: '#004783',
      contrastText: '#fff',
    },
    secondary: {
      main: '#6c757d', // Neutral gray
      light: '#8d959d',
      dark: '#495057',
      contrastText: '#fff',
    },
    error: {
      main: '#dc3545', // Red from error states in the image
      light: '#e35d6a',
      dark: '#b02a37',
    },
    warning: {
      main: '#ffc107',
      light: '#ffcd39',
      dark: '#e5ac06',
    },
    success: {
      main: '#28a745', // Green for succeeded status
      light: '#53b96a',
      dark: '#1f8838',
    },
    info: {
      main: '#17a2b8',
      light: '#45b5c6',
      dark: '#117a8b',
    },
    background: {
      default: '#f8f9fa',
      paper: '#ffffff',
    },
    text: {
      primary: '#343a40',
      secondary: '#6c757d',
    },
  },
  typography: {
    fontFamily: '"Segoe UI", "Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontSize: '2rem',
      fontWeight: 500,
    },
    h2: {
      fontSize: '1.75rem',
      fontWeight: 500,
    },
    h3: {
      fontSize: '1.5rem',
      fontWeight: 500,
    },
    h4: {
      fontSize: '1.25rem',
      fontWeight: 500,
    },
    h5: {
      fontSize: '1.1rem',
      fontWeight: 500,
    },
    h6: {
      fontSize: '1rem',
      fontWeight: 500,
    },
    body1: {
      fontSize: '0.875rem',
    },
    body2: {
      fontSize: '0.8rem',
    },
    button: {
      textTransform: 'none',
      fontWeight: 500,
    },
  },
  shape: {
    borderRadius: 4,
  },
  components: {
    MuiCard: {
      styleOverrides: {
        root: {
          boxShadow: '0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24)',
          borderRadius: '4px',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontWeight: 500,
        },
        containedPrimary: {
          backgroundColor: '#0066b7',
          '&:hover': {
            backgroundColor: '#004783',
          },
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          padding: '8px 16px',
          fontSize: '0.875rem',
        },
        head: {
          fontWeight: 500,
          backgroundColor: '#f8f9fa',
        },
      },
    },
  },
});

export default theme; 